module.exports = __webpack_public_path__ + "static/img/template.fcc45117.svg";